module.exports = __webpack_public_path__ + "80a18ccbc81735924fff1251aef17dba.svg";